import { ExtractPropTypes, PropType } from 'vue'

export const picProps = {
	/**
	 * 图片链接
	 */
	src: {
		type: String,
		default: ''
	},
	/**
	 * 预览图片列表
	 */
	previews: {
		type: Array as PropType<string[]>,
		default: () => []
	},

	/**
	 * 图片替代文本
	 */
	alt: {
		type: String,
		default: ''
	},
	/**
	 * 图片显示模式
	 */
	mode: {
		type: String,
		default: 'default'
	},
	/**
	 * 颜色
	 */
	color: {
		type: String,
		default: 'default'
	},
	/**
	 * 图片宽度
	 */
	width: {
		type: [String, Number],
		default: ''
	},
	/**
	 * 图片高度
	 */
	height: {
		type: [String, Number],
		default: ''
	},
	/**
	 * 图片查看器的z-index
	 */
	zIndex: {
		type: Number,
		default: 2000
	},
	link: {
		type: Boolean,
		default: false
	},
	flex: Boolean
}

export type PicProps = ExtractPropTypes<typeof picProps>
